import {ServiceProviderRepository} from '../repository/ServiceProviderRepository';

export class GetBrandStoresUseCase {
  constructor (private repo: ServiceProviderRepository) {}

  async execute (brandId: string): Promise<any[]> {
    return this.repo.getBrandStores(brandId);
  }
}
